// Brand assets and copy for La Valle degli Iblei
export const BRAND = {
  name: "LA VALLE DEGLI IBLEI",
  tagline: "Selezione d'Autore per l'Alta Ristorazione e l'Export.",
  email: "info@lavalledegliiblei.it",
  founder: "Claudio Pucci",
  location: "Sicilia, Italia",
};

export const ASSETS = {
  logo: "/crest.png",
  claudio: "/claudio-pucci.png",
  terraArsa: "/img/terra-arsa-4k.webp",
  blanche: "/img/blanche-4k.webp",
  scilla: "/img/scilla-4k.webp",
  claire: "/img/claire-mare.webp",
  artisan: "/img/artisan-scene.jpg",
  sommelier: "/img/sommelier-scene.jpg",
  collection: "/img/quattro-cuvee.webp",
};

export const NAV = [
  { id: "filosofia", label: "Filosofia" },
  { id: "collezione", label: "Collezione" },
  { id: "terra-arsa", label: "Terra Arsa" },
  { id: "scilla", label: "Scilla" },
  { id: "blanche", label: "Blanche" },
  { id: "claire", label: "Claire" },
  { id: "sommelier-club", label: "Sommelier" },
  { id: "contatti", label: "Contatti" },
];
